
















































































































































































































import { Component, Prop, Mixins } from "vue-property-decorator";
import { IFilter, ISorter, ITableConfig } from "@/models/tables";
import { mapState } from "vuex";
import { ISocketMessage } from "@/models/socket";
import { IStatus } from "@/models/statuses";
import { ITicket } from "@/models/tickets";
import { TicketStatusCodes } from "@/data/enums/tickets";
import { IState } from "@/store";
import { DataModules } from "@/store/modules/data";
import { FilteringSortingTableStore } from "@/mixins/tableWithFilteringAndSortingStore";
import Context from "@/mixins/context";
import {
  ApiOperators,
  FilterOperators,
  FilterTypes,
  Sorters
} from "@/data/table";
import BrandsStore from "@/mixins/brandsStore";
import AdminBrands from "@/mixins/adminBrands";
import i18n from "@/i18n";
import { IClient } from "@/models/clients";
import { IBrand } from "@/models/brands";
import { IUser } from "@/models/users";
import { ILead } from "@/models/leads";
import { ClientRoutes } from "@/data/enums/router";

@Component({
  computed: {
    ...mapState({
      statuses: (state: IState) => state.constants.statuses.ticket
    })
  }
})
export default class TicketsTable extends Mixins(
  BrandsStore,
  AdminBrands,
  FilteringSortingTableStore,
  Context
) {
  @Prop({ default: null })
  public clientId!: IClient["id"];

  @Prop({ default: null })
  public leadId!: ILead["id"];

  @Prop({ default: null })
  public userId!: IUser["id"];

  @Prop({ default: true })
  public setDefaultStatusFilter!: boolean;

  @Prop({ default: () => ({}) })
  public readonly manualFilters!: Record<string, string | number | boolean>;

  @Prop({ default: "router-link" })
  public rowTag!: string;

  @Prop({ default: false })
  public showStaged!: boolean;

  @Prop({
    default: () => (ticket: ITicket, isClient: boolean) => ({
      to: {
        name: isClient
          ? ClientRoutes.SUPPORT_TICKET
          : "adminSupportTicketModal",
        params: { ticketId: ticket.id }
      }
    })
  })
  public rowProps!: (ticket: ITicket, isClient: boolean) => Record<string, any>;

  @Prop({ default: () => () => ({}) })
  public rowEvents!: (ticket: ITicket) => Record<string, Function>;

  // Override prop defaults from mixin

  @Prop({ default: "TT1" })
  public declare id: string;

  @Prop({ default: 10 })
  public declare limit: number;

  public defaults: ITableConfig = {
    limit: this.limit,
    sort: {
      field: "updated_at",
      direction: Sorters.DESCENDING
    }
  };

  public statuses!: IStatus[];

  public filters: IFilter[] = [
    {
      key: "reference",
      label: i18n.t("_.reference"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "subject",
      label: i18n.t("_.subject"),
      type: FilterTypes.STRING,
      operator: FilterOperators.EQUAL
    },
    {
      key: "created_at",
      label: i18n.t("_.created"),
      type: FilterTypes.DATE,
      operator: FilterOperators.EQUAL
    }
  ];

  public sorters: ISorter[] = [
    {
      field: "reference",
      label: this.$t("_.reference")
    },
    {
      field: "subject",
      label: this.$t("_.subject")
    },
    {
      field: "created_at",
      label: this.$t("_.date_added")
    },
    {
      field: "updated_at",
      label: this.$t("_.last_updated")
    }
  ];

  public dataModule: string = DataModules.TICKETS;

  public async created() {
    this.apiProps = {
      with: ["status", "client", "lead", "client.image", "department"].join(),
      ...(this.showStaged ? { with_staged_imports: 1 } : {})
    };
    await this.setupStatusFilter();
    this.setupSocketListener();
    this.getData();
  }

  public async setupStatusFilter() {
    await this.$store.dispatch("constants/getStatuses", "ticket");
    const options = this.$_.map(this.statuses, status => {
      return { value: status.code, label: status.name };
    });

    this.filters.push({
      key: "status.code",
      label: i18n.t("_.status"),
      type: FilterTypes.SELECT,
      options: options,
      operator: FilterOperators.EQUAL
    });
  }

  // overrides mixin method
  public getStoreParams(payload: any): Promise<any> {
    this.setStatusFilter(payload);
    return {
      ...payload,
      params: {
        ...payload.params,
        ...this.filterForUser,
        ...this.filterForClient,
        ...this.filterForLead,
        ...this.manualFilters // Eg. passed from import
      }
    };
  }

  public get filterForClient() {
    return this.clientId ? { "filter[client_id]": this.clientId } : {};
  }

  public get filterForLead() {
    return this.leadId ? { "filter[lead_id]": this.leadId } : {};
  }

  public get filterForUser() {
    return this.userId ? { "filter[users.id]": this.userId } : {};
  }

  public get compactView() {
    return !this.clientId && !this.leadId;
  }

  public setStatusFilter(payload: any) {
    let hasStatusFilter = false;
    for (const key in payload.params) {
      if (key.startsWith("filter[status.code")) {
        hasStatusFilter = true;
        return false;
      }
    }
    if (!hasStatusFilter && this.setDefaultStatusFilter) {
      payload.params[
        `filter[status.code|${ApiOperators.NOT_EQUAL}]`
      ] = this.$_.compact([
        TicketStatusCodes.CLOSED,
        this.isAdmin && !this.clientId && TicketStatusCodes.AWAITING_RESPONSE
      ]).join(",");
    }
  }

  public setupSocketListener() {
    this.$bus.$on(
      "socket-ticket-status-update",
      async (data: ISocketMessage) => {
        const socketMessage: {
          status_code: ITicket["status"]["code"];
          ticket_id: ITicket["id"];
        } = JSON.parse(data.message);

        const ticket = this.$_.find(this.table.data, [
          "id",
          socketMessage.ticket_id
        ]) as ITicket;

        if (this.$_.isEmpty(ticket)) return;

        const status = this.$_.find(this.statuses, [
          "code",
          socketMessage.status_code
        ]) as ITicket["status"];

        if (this.$_.isEmpty(status)) return;

        ticket.status_id = status.id;
        ticket.status = status;
      }
    );
  }

  public getBrandName(brandId: IBrand["id"]) {
    return this.$_.get(
      this.$_.find(this.brands, brand => {
        return brand.id === brandId;
      }),
      "name",
      ""
    );
  }
}
